
import { useParams } from "react-router-dom";

import { Box } from "@mui/material";
import { DisenioGranja } from "../../layout";
import { useLoteXGranja } from "../../../hooks";
import { CargandoMedio, TablaListadoLotes } from "../../components";




export const LotesXGranja = () => {

    const { id } = useParams();
    const { lotesXGranjaQuery } = useLoteXGranja(id);


    return (

        <DisenioGranja titulo="Lotes de Granja" add={false}>
            {(lotesXGranjaQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Bodegas..." />
            :   <TablaListadoLotes data={lotesXGranjaQuery.data || []} />
            }

            <Box sx={{height:30}} />
        </DisenioGranja>

    )
}
